import { Menu, type MenuClickTriggerProps, type MenuRootProps, type MenuVariantProps } from "@overmap-ai/blocks"
import { assetTypeStatusSortFn } from "@overmap-ai/common"
import { useSort } from "@overmap-ai/hooks"
import { memo, type ReactElement } from "react"

import {
	AssetTypeStatusMultiSelectGroup,
	type AssetTypeStatusMultiSelectGroupProps,
} from "../MenuMultiSelectGroups/AssetTypeStatusMultiSelectGroup"

interface AssetTypeStatusMultiSelectProps
	extends
		MenuRootProps,
		AssetTypeStatusMultiSelectGroupProps,
		MenuVariantProps,
		Omit<MenuClickTriggerProps, "children" | "ref"> {
	children: ReactElement
}

export const AssetTypeStatusMultiSelect = memo((props: AssetTypeStatusMultiSelectProps) => {
	const { children, values, assetTypeStatuses, onValuesChange, disabled, variant, size, accentColor, ...rest } = props

	const sortedAssetTypeStatuses = useSort(assetTypeStatuses, assetTypeStatusSortFn)

	return (
		<Menu.Root {...rest}>
			<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
			<Menu.Content variant={variant} size={size} accentColor={accentColor}>
				<Menu.Scroll>
					<AssetTypeStatusMultiSelectGroup
						values={values}
						assetTypeStatuses={sortedAssetTypeStatuses}
						onValuesChange={onValuesChange}
					/>
				</Menu.Scroll>
			</Menu.Content>
		</Menu.Root>
	)
})
AssetTypeStatusMultiSelect.displayName = "AssetTypeStatusMultiSelect"
